module.exports = __webpack_public_path__ + "static/media/video-anime.c596357d.png";